import Footer from "../components/Footer";

export default function TermsPage({ onNav }) {
  const Section = ({ title, children }) => (
    <div style={{ marginBottom: 28 }}>
      <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:18, fontWeight:700, color:"#1a1a2e", marginBottom:10 }}>{title}</h3>
      <div style={{ fontSize:14, color:"#555", lineHeight:1.8 }}>{children}</div>
    </div>
  );

  return (
    <div className="page-top-pad" style={{ background:"white", minHeight:"100vh" }}>
      <div style={{ background:"linear-gradient(135deg,#1a1a2e,#2d1b69)", padding:"28px clamp(16px,4vw,40px)" }}>
        <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:"clamp(22px,4vw,34px)", fontWeight:900, color:"white" }}>Terms & Conditions</h1>
        <p style={{ fontSize:12, color:"rgba(255,255,255,0.7)", marginTop:6 }}>Last updated: {new Date().toLocaleDateString("en-IN",{year:"numeric",month:"long",day:"numeric"})}</p>
      </div>

      <div style={{ maxWidth:760, margin:"0 auto", padding:"clamp(24px,5vw,48px) clamp(16px,4vw,40px)" }}>
        <div style={{ background:"#FFFBEB", border:"1px solid #FDE68A", borderRadius:10, padding:"12px 16px", fontSize:12, color:"#92400E", marginBottom:28 }}>
          ⚠️ Ye ek starting template hai. Business-specific details (GST number, jurisdiction, exact policies) ke hisaab se ise ek legal professional se review karwa lena chahiye.
        </div>

        <Section title="1. About Matchwell">
          Matchwell ("we", "us", "our") is a ladies clothing showroom established in 1979, located at Gulmandi Corner,
          Chhatrapati Sambhajinagar (Aurangabad), Maharashtra. This website (ematchwell.com) is operated by Matchwell.
          By accessing or using this website, you agree to be bound by these Terms & Conditions.
        </Section>

        <Section title="2. Eligibility">
          You must be at least 18 years old to place an order on this website, or have the involvement of a parent/guardian.
        </Section>

        <Section title="3. Product Information">
          We make every effort to display our products' colours and details as accurately as possible. However, actual
          colours may vary slightly depending on your device's display settings. Fabric measurements are provided as a
          general guide and may vary by ±2% due to the handmade/tailored nature of some products.
        </Section>

        <Section title="4. Pricing & Payment">
          All prices are listed in Indian Rupees (₹) and are inclusive of applicable taxes unless stated otherwise.
          Payments are processed securely through Razorpay. We do not store your card, UPI, or banking details on our
          servers.
        </Section>

        <Section title="5. Order Confirmation">
          An order is confirmed once payment is successfully received and you receive an order confirmation. We reserve
          the right to cancel any order due to stock unavailability, pricing errors, or suspected fraud, in which case a
          full refund will be issued.
        </Section>

        <Section title="6. Shipping">
          Estimated delivery timelines are shown at checkout and on each product page, based on your delivery pincode.
          These are estimates only and may be affected by courier delays, weather, or public holidays.
        </Section>

        <Section title="7. Returns & Exchanges">
          Please see our <span onClick={()=>onNav("returns")} style={{color:"#EC4899",cursor:"pointer",fontWeight:700}}>Return & Exchange Policy</span> for full details.
        </Section>

        <Section title="8. Limitation of Liability">
          Matchwell shall not be liable for any indirect, incidental, or consequential damages arising from the use of
          this website or products purchased through it, to the maximum extent permitted by law.
        </Section>

        <Section title="9. Governing Law">
          These terms are governed by the laws of India, and any disputes shall be subject to the jurisdiction of the
          courts in Chhatrapati Sambhajinagar, Maharashtra.
        </Section>

        <Section title="10. Contact Us">
          For any questions about these Terms, please reach out via WhatsApp or visit our{" "}
          <span onClick={()=>onNav("contact")} style={{color:"#EC4899",cursor:"pointer",fontWeight:700}}>Contact Us</span> page.
        </Section>
      </div>
      <Footer onNav={onNav}/>
    </div>
  );
}
